export class GACategoryTypes {
  static TrackingContactUs = 'TrackingContactUs';
  static JobOffers = 'JobOffers';
}
